angular.module('impactx.product').controller('RecommendedProductsCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    RecommendedProductsCtrl
]);

function RecommendedProductsCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {}, '/product/recommendedproducts');
}